import React from 'react'
import style from './audit.module.sass'
import moment from 'moment'
import { AuditResponseData } from './auditInterface'

interface Props {
    item : AuditResponseData
}

const renderTagsFromString = (text: string) => {
    const matchcomma = /"/g

    const idxArray = []
    let i = matchcomma.exec(text)
    i && idxArray.push(i.index)
    while(i !== null){
        i = matchcomma.exec(text)
        if(i !== null) {
            idxArray.push(i.index)
        }
    }
    
    const isFirst = idxArray.length > 0 && idxArray[0] === 0
    let it = 0
    let renderArr = []
    while(it < idxArray.length){
        let taggableStr: string; 
        let remainingStr: string; 
        if(isFirst){
            taggableStr = text.slice(idxArray[it] + 1, idxArray[it + 1])
            remainingStr = text.slice(idxArray[it + 1] + 1,idxArray[it + 2])
        } else {
            if(it === 0) {
                remainingStr = text.slice(0,idxArray[it])
        
            } else {
                remainingStr = text.slice(idxArray[it-1]+1,idxArray[it])
            }
            taggableStr = text.slice(idxArray[it]+1,idxArray[it+1])
        }
        renderArr.push(
            <span key={it}>
                {
                isFirst ? (
                    <>
                    <span className={style.tagText}>{taggableStr}</span>
                    <span>{remainingStr}</span>
                    </>
                ) : (
                    <>
                    <span>{remainingStr}</span>
                    <span className={style.tagText}>{taggableStr}</span>
                    </>
                )
                }
            </span>
        )
        it = it + 2
    }
    if(!isFirst) {
        renderArr.push(<span>{text.slice(idxArray[idxArray.length-1]+1)}</span>)
    }
    return renderArr
}

export const AuditRecordHeader = (props: Props) => {

    const { item } = props

    return (
        <span className={style.panelHeader}>
            <span className={style.panelOperation}>
                {item.operation}
            </span>
            <span className={style.panelSummary}>
                <span>
                    {renderTagsFromString(item.text_payload)}   
                </span>
                <span className={style.panelTimestamp}>
                    {moment(item.created_at).format("MM-DD-YYYY hh:mm:ss:SS A")}
                </span>
            </span>
        </span>
    )
}